import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BusinessInformationComponent } from './business-information.component';
import { CanActivateSessionGuard } from '../services/can-activate-session-guard.service';

const routes: Routes = [
    {
        path: 'business-information',
        component: BusinessInformationComponent,
        canActivate: [
            CanActivateSessionGuard
        ]
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class BusinessInformationRoutingModule { }
